import {MDCDrawer} from "@material/drawer";
import {MDCTopAppBar} from "@material/top-app-bar";

import {MDCTextField} from '@material/textfield';
import {MDCNotchedOutline} from '@material/notched-outline';

import {MDCFormField} from '@material/form-field';
import {MDCCheckbox} from '@material/checkbox';

import {MDCList} from '@material/list';
import {MDCRipple} from '@material/ripple';

import {MDCTextFieldHelperText} from '@material/textfield/helper-text';

/**
 * Drawer - the main component in the Login page UI for the page structure
 * Documentation: https://material.io/develop/web/components/drawers/
*/ 
const drawer = MDCDrawer.attachTo(document.querySelector('.mdc-drawer'));

/**
 * Top App Bar - The top navigation bar used in the login page
 * In the smaller resolution it helps to close or open the aside drawer
 * Documentation: https://material.io/develop/web/components/top-app-bar/
 */
const topAppBar = MDCTopAppBar.attachTo(document.getElementById('app-bar'));
topAppBar.setScrollTarget(document.getElementById('main-content'));
topAppBar.listen('MDCTopAppBar:nav', () => {
  drawer.open = !drawer.open;
});

/**
 * Checkbox - Remember me checkbox
 * Documentation: https://material.io/develop/web/components/input-controls/checkboxes/
 */
//const checkboxRememberMe = new MDCCheckbox(document.querySelector('.mdc-checkbox'));
//const formField = new MDCFormField(document.querySelector('.mdc-form-field'));
//formField.input = checkboxRememberMe;

/**
 * Text Fields - The text field component is being used for input fields(username and password)
 * Documentation: https://material.io/components/web/catalog/input-controls/text-field/
 */
// Text field username
const textFieldUsername = new MDCTextField(document.querySelector('#mdc-text-field--ws-username'));
// Text field Password
//const textFieldPassword = new MDCTextField(document.querySelector('#mdc-text-field--ws-password'));

/**
 * Notched Outline - To have a border around all sides of the Text Fields
 * Documentation: https://material.io/develop/web/components/input-controls/notched-outline/
 */
const notchedOutline = new MDCNotchedOutline(document.querySelector('.mdc-notched-outline'));

/**
 * Helper Text - Helper text gives context about a field’s input. 
 * It is used for showing required field validation.
 * Documentation: https://material.io/develop/web/components/input-controls/text-field/helper-text/
 */
const helperText = new MDCTextFieldHelperText(document.querySelector('.mdc-text-field-helper-text'));

/**
 * Lists - It is used to show the items in aside menu of the drawer(mobile devices)
 * Documentation: https://material.io/develop/web/components/lists/ 
 */
const list = new MDCList(document.querySelector('.mdc-list'));
const listItemRipples = list.listElements.map((listItemEl) => new MDCRipple(listItemEl));

/**
 * Button Ripple - The button will work without JavaScript
 * Here is is used to have a ripple effect by instantiating 
 * Documentation: https://material.io/develop/web/components/buttons/
 */
const buttonRippleLogin = new MDCRipple(document.querySelector('.mdc-button'));

/**
* submitForm() is a function can be utilized for page AJAX call
*/
function submitForm() {
  // Do AJAX call here
 console.log('Write logic for authentication API call');
}

/**
 * Here is the module export() - which exports the internal function of the JS file
 * We can use it as login.confirmation() outside the scope of this file
 * Why login.<function>? The file will export as login module. The configuration is mentioned in ./webpack.config.js
 * Refer: login.cfm for the use
*/
export {
  submitForm
};
